import en from './en';
import pt from './pt';

export default {
  en,
  pt,
};
